import { useEffect, useContext, useRef, useCallback } from 'react';
import I18n from 'I18n';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { SearchInput } from 'foundations-components/transitional/components/SearchInput';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import SegmentationFiltersInstanceContext from '../../../../state/SegmentationFiltersInstanceContext';
import { jsx as _jsx } from "react/jsx-runtime";
const Search = ({
  value,
  onSearchChange,
  searchPlaceholderAssetLabel
}) => {
  const {
    selectedFilterFamilyGroup,
    selectedCategory,
    props: {
      uiMessages: {
        filterCategorySearchInputPlaceholder
      }
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const inputRef = useRef(null);
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [selectedFilterFamilyGroup, selectedCategory]);
  useEffect(() => {
    onSearchChange(syntheticEvent(''));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilterFamilyGroup, selectedCategory]);
  const getPlaceholderMessage = useCallback(() => {
    return searchPlaceholderAssetLabel ? I18n.text('customerDataFiltersUI.dataExplorer.search.placeholderWithAsset', {
      assetLabel: searchPlaceholderAssetLabel
    }) : I18n.text('customerDataFiltersUI.dataExplorer.search.genericPlaceholder');
  }, [searchPlaceholderAssetLabel]);
  return /*#__PURE__*/_jsx(FormControl, {
    "aria-label": I18n.text('newCustomerDataFilters.fieldSelectFlow.filterFamilySelectLabel'),
    children: /*#__PURE__*/_jsx(SearchInput, {
      "data-selenium-test": "fr-filter-search-input",
      inputRef: inputRef,
      onChange: evt => onSearchChange(evt),
      placeholder: filterCategorySearchInputPlaceholder || getPlaceholderMessage(),
      value: value
    })
  });
};
export default Search;